import { combineReducers } from 'redux';

import unitMeasurement from './unit-measurement';
import unitMeasurements from './unit-measurements';

export default combineReducers({
    unitMeasurement,
    unitMeasurements
});
